import { Stack, Slot } from 'expo-router';
import { DesktopShell } from '@/components/DesktopShell';
import { useIsDesktop } from '@/hooks/useIsDesktop';

export default function PersonalLayout() {
  const isDesktop = useIsDesktop();

  // Em desktop: shell único com sidebar envolvendo todas as telas do personal.
  // No mobile: Stack normal do Expo Router com as opções de cada screen.
  if (isDesktop) {
    return (
      <DesktopShell>
        <Slot />
      </DesktopShell>
    );
  }

  return (
    <Stack screenOptions={{ headerTintColor: '#C8102E', headerBackTitle: '' }}>
      <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
      <Stack.Screen name="students/[id]" options={{ title: '' }} />
      <Stack.Screen name="students/new" options={{ headerShown: false }} />
      <Stack.Screen name="plans/[id]" options={{ title: '' }} />
      <Stack.Screen name="plans/new" options={{ title: 'Novo Treino' }} />
      <Stack.Screen name="routines/[routineId]" options={{ title: '' }} />
      <Stack.Screen name="routines/new" options={{ title: 'Nova Rotina' }} />
      <Stack.Screen name="routines/new-from-suggestion" options={{ title: 'Criar Rotina com IA' }} />
      <Stack.Screen name="progress/[studentId]" options={{ title: '' }} />
      <Stack.Screen name="feedback/[studentId]" options={{ title: '' }} />
      <Stack.Screen name="chat" options={{ headerShown: false }} />
      <Stack.Screen name="finances" options={{ title: 'Financeiro' }} />
      <Stack.Screen name="retencao/index" options={{ title: 'Área de Retenção' }} />
      <Stack.Screen name="my-workout/index" options={{ title: 'Meu treino' }} />
      <Stack.Screen name="workout/[planId]" options={{ title: '' }} />
      <Stack.Screen name="profile" options={{ title: 'Meu Perfil' }} />
    </Stack>
  );
}
